export const sliders = {
  MuiSlider: {
    styleOverrides: {
      // Name of the slot
      root: ({ theme }) => ({
        // Some CSS
        "& .MuiSlider-valueLabelOpen": {
          color: theme.palette.primary.main,
          // backgroundColor: theme.palette.background.main
        },
      }),
    },
  },
};
